// extracted by mini-css-extract-plugin
module.exports = {"wrap":"wrap__1pAX9","title":"title__uojf9","form":"form__2NetV","textarea":"textarea__P6eRg","modal":"modal__3jqxf","list":"list__2qxZ2","list-item":"list-item__2Tjg2"};